<template>
  <kye-dialog
    width="400px"
    title="组织树"
    :visible.sync="show"
    :canResize="false"
    :showFullScreenButton="false"
    @close="onClose">
    <kye-form :model="form">
      <kye-form-item label="组织名称" prop="department">
        <kye-search-tips
          v-model="form.department"
          style="width:170px;"
          placeholder="请输入组织名称"
          clearable
          value-key="name"
          :axios="axios"
          :url="searchUrl"
          :keys="['parentName','name']"
          :format-data="searchDepartmentParams"
          :format-result="searchFormatResult"
          @select="chooseDepartment"
          @clear="clearDepartment">
        </kye-search-tips>
        <span style="padding-left:16px;">{{bakMonthLabel}}</span>
      </kye-form-item>
    </kye-form>
    <div v-loading="load"
         style="height:calc(60vh - 110px);overflow-y:auto;"
         ref="scrollBar">
      <KyeOrgTree
        v-if="authTree[0]"
        ref="tree"
        accordion
        highlight-current
        node-key="id"
        expand-on-click-node
        :data="authTree"
        :default-expanded-keys="defaultExpandedKeys"
        :props="{label: 'name', children: 'children'}"
        :filter-node-method="filterNode"
        @node-click="nodeClick">
      </KyeOrgTree>
      <p v-if="field.auth && init" class="center">无权限获取组织数据，请联系HR同事</p>
    </div>
    <template slot="footer">
      <el-checkbox v-if="containLeaf" v-model="checked" style="float:left;">是否包含子节点</el-checkbox>
      <el-button type="primary" hotkey="ctrl+s" @click="saveSelectedDept">保存(S)</el-button>
      <el-button @click="show = false">取消</el-button>
    </template>
  </kye-dialog>
</template>

<script>
  import KyeOrgTree from 'public/components/kye-tree'
  import { setModelValue } from '../../utils'
  import {
    fetchGenericTreeData,
    mapDepts,
    getPosterity,
    runFetchAxios,
    hasAllTreeAuth,
    encodeKey
  } from './utils'

  export default {
    name: 'dept-dialog',
    components: { KyeOrgTree },
    props: {
      model: Object,
      axios: {
        type: Object,
        default: () => ({})
      },
      preloadDeptTree: {
        type: Boolean,
        default: true
      },
      checkNodeSelect: Function
    },
    inject: {
      queryForm: {
        default: () => ({})
      }
    },
    data () {
      return {
        show: false,
        load: false,
        checked: true,
        init: false,
        bakMonth: '',
        authTree: [],
        field: {},
        form: {
          departmentId: '',
          department: ''
        }
      }
    },
    mounted () {
      this.preloadDeptTree && this.$bus.$emit('preload-dept-tree')
    },
    computed: {
      containLeaf () {
        return this.field.$attr ? this.field.$attr.containLeaf !== false : this.field.containLeaf !== false
      },
      deptCache () {
        return this.field.$attr ? this.field.$attr.deptCache !== false : this.field.deptCache !== false
      },
      searchUrl () {
        let url = this.queryForm && this.queryForm.option && this.queryForm.option.deptSearchUrl ? this.queryForm.option.deptSearchUrl : 'hr.department.refactoring.getByFuzzyValue'
        return this.bakMonth ? 'hr.departmentBak.getByFuzzyValue' : url
      },
      threeLevelTreeUrl () {
        // return this.bakMonth ? 'hr.departmentBak.getThreeLevelAsTree' : 'hr.department.refactoring.getThreeLevelAsTree'
        // 2021-11-23 搜索结果支持配置接口
        let url = this.queryForm && this.queryForm.option && this.queryForm.option.deptSearchResultUrl ? this.queryForm.option.deptSearchResultUrl : 'hr.department.refactoring.getThreeLevelAsTree'
        return this.bakMonth ? 'hr.departmentBak.getThreeLevelAsTree' : url
      },
      bakMonthLabel () {
        return this.bakMonth ? `历史数据：${this.bakMonth}` : '实时数据'
      },
      defaultExpandedKeys() {
        try {
          let expandeId = ''
          if (Array.isArray(this.field.queryValue2) && this.field.queryValue2.length) {
            const [_expandeId] = this.field.queryValue2
            expandeId = _expandeId
          }
          const [row] = this.authTree || []
          const { id } = row || {}
          const { departmentId } = this.form
          const ids = [id, departmentId, expandeId].filter(Boolean)
          return ids
        } catch (e) {
          console.error(e)
          return []
        }
      }
    },
    methods: {
      // 搜索部门
      searchDepartmentParams (val) {
        return this.bakMonth ? { fuzzyValue: val, bakMonth: this.bakMonth } : { fuzzyValue: val }
      },
      // 2021-11-02 过滤搜索结果
      searchFormatResult (res) {
        const formatResult = this.field.formatResult || (this.field.$attr && this.field.$attr.formatResult)
        return formatResult ? formatResult(res) : res
      },
      chooseDepartment (item) {
        const isNext = this._checkNodeSelect(item)
        if (isNext === false) {
          return this.$nextTick(() => this.clearDepartment())
        }

        if (item) {
          let id = item.id
          this.form.departmentId = id
          this.form.department = item.name
          this.ids = [id]
          this.init = false
          if (this.hasAllTree) {
            this.$refs.tree.filter(id)
          } else {
            this.filterTree(id)
          }
        } else {
          this.clearDepartment()
        }
      },
      clearDepartment () {
        this.form.departmentId = ''
        this.form.department = ''
      },
      onClose () {
        this.clearDepartment()
      },
      open (field) {
        this.field = field
        this.bakMonthCache = this.bakMonthCache || {}
        let bakMonthConf = runFetchAxios(field)
        let cacheKey = ''
        let hasBakMonth = false
        if (bakMonthConf) {
          cacheKey = encodeKey(JSON.stringify(bakMonthConf.data))
          hasBakMonth = this.deptCache && this.bakMonthCache[cacheKey]
          this.bakMonth = bakMonthConf.data.bakMonth
        } else {
          this.bakMonth = ''
        }
        // authTree为空、缓存的历史数据不存在、不需要缓存
        // 2021-10-14 如果有需要缓存的历史数据，缓存历史数据不存在情况
        // 2021-10-25 query-table判断是否有预加载的组织树
        let needReq = !this.authTree.length || (bakMonthConf && !hasBakMonth) || !this.deptCache
        if (needReq) {
          // 2021-11-23 通用查询配置项，是否拥有白名单权限
          const allTreeAuth = this.queryForm && this.queryForm.option && this.queryForm.option.hasAllTreeAuth
          this.show = true
          this.load = true
          this.hasAllTree = hasAllTreeAuth() || allTreeAuth
          const auth = field.auth || (field.$attr && field.$attr.auth)
          const fetchData = field.fetchData || (field.$attr && field.$attr.fetchData)
          const promise = fetchData ? fetchData() : fetchGenericTreeData(auth, field, this.axios, allTreeAuth)
          promise
            .then(res => {
              if (!res || !res.id || !res.parentId || !res.children) {
                this.init = true
                this.load = false
                return
              }
              // 缓存历史数据
              if (this.bakMonth && this.deptCache) {
                this.bakMonthCache[cacheKey] = res
              }
              // 过滤节点
              const filterData = field.filterData || (field.$attr && field.$attr.filterData)
              res = filterData ? filterData(res) : res
              this.initData(res, this.hasAllTree && !fetchData && !auth && !this.bakMonth)
              this.init = false
              this.load = false
              // this.collapseLevel2(field)
              this.setHighlightNode()
            })
            .catch(e => {
              this.load = false
              throw e
            })
        } else {
          this.show = true
          this.setHighlightNode()
          // this.collapseLevel2(field)
        }
      },
      filterNode (val, data) {
        let flag = val === data.id
        if (flag) {
          this.setCheckedDept(this.ids)
        }
        return flag
      },
      saveSelectedDept () {
        let node = this.$refs.tree.getCurrentNode()
        if (node) {
          let value = null
          let id = node.id
          if (!this.deptMap[id]) {
            return this.$message.warning('请先选择')
          }
          let ids = this.deptMap[id].children
          if (this.checked && ids) {
            if (this.field.posterity || (this.field.$attr && this.field.$attr.posterity)) {
              value = getPosterity(this.deptMap, [id], ids)
            } else {
              value = [id].concat(ids)
            }
          } else {
            value = [id]
          }

          // 选中节点详情
          let idsInfo = value || []
          idsInfo = idsInfo.reduce((prev, id) => {
            const curInfo = this.deptMap[id]
            if (!curInfo) {
              return prev
            }
            const obj = {
              id: id,
              name: curInfo.name,
              departmentIdRoute: curInfo.departmentIdRoute,
              departmentRoute: curInfo.departmentRoute,
              level: curInfo.level
            }
            prev.push(obj)
            return prev
          }, [])

          // 格式化数据
          const originValue = value
          const formatData = this.field.formatData || (this.field.$attr && this.field.$attr.formatData)

          if (value && formatData) {
            value = formatData({ value, map: this.deptMap, tree: this.authTree })
          }
          this.field._queryValue = [{ label: node.name, value: originValue }]
          this.field.queryValue2 = value
          let key = this.field.propertyName

          let data = {
            key,
            value,
            idsInfo,
            model: this.model,
            leaf: this.checked,
            field: this.field,
            deptMap: this.deptMap,
            tree: this.authTree
          }
          // 自定义查询
          if (this.model) {
            setModelValue(value, this.model, key)
          }
          // callback change
          let fn = this.field.change || (this.field.$attr && this.field.$attr.change)
          if (fn && typeof fn === 'function') {
            fn(data)
          }
          this.$emit('change', data)
          this.show = false
        } else {
          this.$message.warning('请先选择')
        }
      },
      setCheckedDept (ids) {
        // 展开指定的部门，并且滚动到该元素所在位置
        this.$nextTick(_ => {
          this.$refs.tree.setCurrentKey(ids[0])
          this.$nextTick(_ => {
            let dom = this.$refs.scrollBar.querySelector('.el-tree-node.is-expanded.is-current')
            if (dom) {
              let top = dom.offsetTop - 26
              this.$refs.scrollBar.scrollTo({ top, behavior: 'smooth' })
            }
          })
        })
      },
      filterTree (id) {
        let params = this.bakMonth ? { id, bakMonth: this.bakMonth } : { id }
        this.$http(this.threeLevelTreeUrl, params, this.axios).then(this.initData)
      },
      initData (data, all) {
        this.deptMap = all ? (this.$store.state.orgTree.deptMap || {}) : mapDepts({}, data, data.children)
        if (this.deptMap[data.id]) {
          this.level2Ids = this.deptMap[data.id].children
        }
        this.authTree = [data]
      },
      nodeClick (data) {
        const isNext = this._checkNodeSelect(data)
        if (isNext === false) {
          return this.$nextTick(() => {
            this.setCheckedDept([null])
          })
        }

        this.form.department = data.name
      },
      collapseLevel2 (field) {
        if (!this.hasAllTree) return
        this.$nextTick(_ => {
          let tree = this.$refs.tree
          let arr = field._queryValue || []
          let ids = arr[0] ? arr[0].value : null
          if (ids) {
            this.ids = ids
            tree.filter(ids[0])
          } else {
            let map = tree.store.nodesMap
            this.level2Ids && this.level2Ids.some(v => {
              let node = map[v]
              if (node && node.expanded) {
                node.collapse()
                return true
              }
              return false
            })
            tree.setCurrentKey(null)
          }
        })
      },
      setHighlightNode() {
        try {
          this.$nextTick(() => {
            const [id] = this.field.queryValue2 || []
            if (!id) return
            const node = this.deptMap[id] || {}
            this.$refs.tree && this.$refs.tree.setCurrentNode(node)
          })
        } catch (e) {
          console.error(e)
        }
      },
      // 检查是组织是否可选
      _checkNodeSelect (item) {
        try {
          const checkNodeSelect = this.$props.checkNodeSelect
          const isNext = typeof checkNodeSelect === 'function' ? checkNodeSelect(item) : true
          return isNext
        } catch (e) {
          console.error('【query-table】', '_checkNodeSelect')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/query-table/dept-dialog.vue